import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/inquiries`;

export const STATUS_META = {
  new: { label: 'New', tone: 'bg-orange-100 text-orange-800' },
  in_progress: { label: 'In Progress', tone: 'bg-sky-100 text-sky-800' },
  resolved: { label: 'Resolved', tone: 'bg-emerald-100 text-emerald-800' },
};

export const NOTIFY_META = {
  sent: { label: 'Team notified', tone: 'text-emerald-700' },
  pending: { label: 'Notification pending', tone: 'text-zinc-500' },
  failed: { label: 'Notification failed', tone: 'text-red-600' },
  not_configured: { label: 'Email not configured', tone: 'text-red-600' },
};

export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { timeZone: 'America/Los_Angeles', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : '—');

export const useInquiriesApi = () => {
  const { token } = useAuth();
  const call = useCallback(async (method, path, data) => {
    const res = await axios({ method, url: `${API}${path}`, data, headers: { Authorization: `Bearer ${token}` } });
    return res.data;
  }, [token]);
  return useMemo(() => ({
    stats: () => call('get', '/stats'),
    staff: () => call('get', '/staff'),
    list: (params) => call('get', `?${new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([, v]) => v)))}`),
    get: (id) => call('get', `/${id}`),
    update: (id, body) => call('patch', `/${id}`, body),
    note: (id, body) => call('post', `/${id}/notes`, { body }),
    retry: (id) => call('post', `/${id}/retry-notification`),
    moveToLead: (id) => call('post', `/${id}/move-to-lead`),
  }), [call]);
};
